"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[803],{

/***/ 7122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Comments; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(3345);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var dist_index_esm = __webpack_require__(3234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__(4995);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
;// CONCATENATED MODULE: ./components/Comments/styles.ts




var Comments = (0,stitches_config/* styled */.zo)("div", {
    "& h4": {
        fontSize: "32px !important",
        marginBottom: 24
    }
});
var Comment = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    "&:not(:last-of-type)": {
        marginBottom: 32
    },
    "& h4": {
        fontSize: "32px !important",
        marginBottom: 24
    }
});
var Box = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    display: "flex"
});
var Right = (0,stitches_config/* styled */.zo)("div", {
    marginLeft: 24,
    paddingBottom: 16,
    flex: 1,
    width: "calc(100% - 80px)",
    borderBottom: "solid 1px",
    borderBottomColor: "$grey300"
});
var Name = (0,stitches_config/* styled */.zo)("label", {
    marginBottom: 6,
    display: "block",
    fontSize: (0,polished_esm/* rem */.hO)(16),
    fontFamily: "$domine",
    fontWeight: "bold",
    color: "$grey900"
});
var Menssage = (0,stitches_config/* styled */.zo)("p", {
    marginBottom: 16,
    width: "100%",
    fontFamily: "$raleway",
    fontSize: (0,polished_esm/* rem */.hO)(13),
    color: "$grey600"
});
var Hour = (0,stitches_config/* styled */.zo)("time", {
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    fontFamily: "$raleway",
    fontSize: (0,polished_esm/* rem */.hO)(11),
    color: "$grey600",
    "@sm": {
        position: "absolute",
        right: 0,
        top: 0,
        marginBottom: 0
    },
    "& svg": {
        marginRight: 8
    }
});
var Actions = (0,stitches_config/* styled */.zo)("div", {
    display: "flex"
});
var ActionsButtons = (0,stitches_config/* styled */.zo)("button", {
    all: "unset",
    display: "flex",
    alignItems: "center",
    fontFamily: "$raleway",
    fontSize: (0,polished_esm/* rem */.hO)(11),
    color: "$grey600",
    cursor: "pointer",
    "& svg": {
        marginRight: 8
    },
    "&:hover": {
        opacity: 0.8
    },
    "&:not(:last-of-type)": {
        marginRight: 16
    }
});
var Form = (0,stitches_config/* styled */.zo)("form", {
    marginTop: 56
});
var Grid = (0,stitches_config/* styled */.zo)(layout_dist_index_esm/* Grid */.rj, {
    gridTemplateColumns: "repeat(1, 1fr)",
    "@md": {
        gridTemplateColumns: "repeat(2, 1fr)"
    }
});
var styles_Button = (0,stitches_config/* styled */.zo)(Button/* default */.Z, {
    position: "relative",
    marginTop: 56,
    "& svg": {
        marginLeft: 5,
        marginTop: "-2px"
    }
});
var CommentBox = (0,stitches_config/* styled */.zo)("div", {
    padding: "25px",
    border: "1px solid #eee",
    marginBottom: "24px",
    borderRadius: "15px"
});
var SubComments = (0,stitches_config/* styled */.zo)("div", {
    marginLeft: 40,
    padding: 20,
    transform: "scale(0.9)"
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./pages/components/Loading/index.js
var Loading = __webpack_require__(3229);
// EXTERNAL MODULE: ./pages/components/AlertComponent/index.js
var AlertComponent = __webpack_require__(64);
// EXTERNAL MODULE: ./services/api.ts
var api = __webpack_require__(9419);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(5313);
// EXTERNAL MODULE: ./utils/useRecaptcha.js
var useRecaptcha = __webpack_require__(9210);
;// CONCATENATED MODULE: ./components/Comments/index.js















var Container = function(param) {
    var comments = param.comments, postId = param.postId;
    var ref = (0,useRecaptcha/* useRecaptcha */.Z)(), isValid = ref.isValid, reply = ref.reply, question = ref.question;
    var truncateString = function(str, num) {
        if (str.length > num) {
            return str.slice(0, num) + "...";
        }
        return str;
    };
    var formRef = (0,react.useRef)();
    var ref1 = (0,react.useState)(), selectedComment = ref1[0], setSelectedComment = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(false), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(false), success = ref4[0], setSuccess = ref4[1];
    var handleSelectComment = function(comment, index) {
        setSelectedComment((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
            index: index
        }));
        formRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    var ref5 = (0,react_hook_form_dist_index_esm/* useForm */.cI)(), register = ref5.register, handleSubmit = ref5.handleSubmit, reset = ref5.reset, getValues = ref5.getValues, errors = ref5.formState.errors;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        payload = {
                            data: data,
                            action: (selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.name) ? "replyToComment" : "addComment",
                            origin: window.location.href,
                            postId: postId
                        };
                        if (selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.name) payload.commentIndex = selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.index;
                        _ctx.next = 6;
                        return api/* apiSameOrigin.post */.Y8.post("/comments", payload);
                    case 6:
                        setSuccess(true);
                        setError(false);
                        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
                        reset();
                        setTimeout(function() {
                            setSuccess(false);
                        }, 5000);
                        _ctx.next = 18;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        setError(true);
                        setSuccess(false);
                        setTimeout(function() {
                            setError(false);
                            setSuccess(false);
                        }, 5000);
                    case 18:
                        _ctx.prev = 18;
                        setLoading(false);
                        return _ctx.finish(18);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13,
                    18,
                    21
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Comments, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                isLoading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertComponent/* default */.Z, {
                show: success,
                title: "Coment\xe1rio Enviado",
                status: "success",
                description: "Obrigado por enviar seu coment\xe1rio!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertComponent/* default */.Z, {
                show: error,
                title: "Oops",
                status: "error",
                description: "Houve um erro ao enviar, tente novamente mais tarde."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                children: [
                    comments ? (0,utils/* countComments */.M)(comments) : "0",
                    " Coment\xe1rios"
                ]
            }),
            comments && (comments === null || comments === void 0 ? void 0 : comments.map(function(comment, i) {
                return comment.status && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Comment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Avatar */.qE, {
                                    size: "md",
                                    name: comment === null || comment === void 0 ? void 0 : comment.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Right, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                            children: truncateString(comment === null || comment === void 0 ? void 0 : comment.name, 20)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menssage, {
                                            children: comment === null || comment === void 0 ? void 0 : comment.message
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionsButtons, {
                                                onClick: function() {
                                                    return handleSelectComment(comment, i);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "14",
                                                        height: "12",
                                                        viewBox: "0 0 14 12",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M5.49366 1.21296C5.51575 1.20128 5.53993 1.19646 5.56398 1.19894C5.58803 1.20141 5.61117 1.2111 5.63128 1.22712C5.6514 1.24313 5.66783 1.26496 5.67908 1.29059C5.69033 1.31622 5.69603 1.34483 5.69566 1.3738V2.75778C5.69566 2.91696 5.74834 3.06961 5.84211 3.18216C5.93588 3.29472 6.06306 3.35795 6.19566 3.35795C6.86266 3.35795 8.20866 3.36395 9.49566 4.34462C10.4797 5.09363 11.4857 6.4572 12.0907 8.99711C11.0707 7.81718 9.90566 7.1774 8.88566 6.83771C8.25871 6.62986 7.61439 6.50666 6.96466 6.47041C6.69871 6.45639 6.43233 6.45959 6.16666 6.48001H6.15366L6.14866 6.48121L6.19566 7.07898L6.14566 6.48121C6.02225 6.4961 5.90785 6.56552 5.82468 6.67599C5.74152 6.78646 5.69554 6.93009 5.69566 7.07898V8.46296C5.69566 8.59259 5.58566 8.67422 5.49366 8.6238L1.50966 5.10323C1.49614 5.09119 1.48212 5.07997 1.46766 5.06962C1.44592 5.05394 1.42793 5.03177 1.41544 5.00526C1.40295 4.97876 1.39638 4.94883 1.39638 4.91838C1.39638 4.88793 1.40295 4.858 1.41544 4.83149C1.42793 4.80499 1.44592 4.78282 1.46766 4.76714C1.48213 4.75679 1.49615 4.74558 1.50966 4.73353L5.49366 1.21296ZM6.69566 7.66234C6.76366 7.66234 6.83866 7.66594 6.91866 7.66954C7.35266 7.69355 7.95266 7.77277 8.61866 7.99483C9.94466 8.43655 11.5147 9.43763 12.5587 11.6918C12.6151 11.8135 12.7051 11.9079 12.8131 11.9587C12.9212 12.0095 13.0406 12.0136 13.1508 11.9703C13.2611 11.927 13.3555 11.839 13.4176 11.7214C13.4798 11.6039 13.506 11.464 13.4917 11.3257C13.0277 6.87252 11.6057 4.52947 10.0317 3.33154C8.78666 2.38328 7.50466 2.20083 6.69566 2.16602V1.3738C6.69576 1.12661 6.64026 0.883982 6.53503 0.671504C6.42981 0.459025 6.27875 0.284581 6.0978 0.166577C5.91685 0.0485736 5.71271 -0.00861364 5.50694 0.00104998C5.30117 0.0107136 5.10138 0.0868696 4.92866 0.221482L0.934665 3.75046C0.769545 3.87417 0.633371 4.0463 0.538963 4.25062C0.444555 4.45494 0.39502 4.68474 0.39502 4.91838C0.39502 5.15202 0.444555 5.38182 0.538963 5.58614C0.633371 5.79046 0.769545 5.96258 0.934665 6.0863L4.92866 9.61528C5.10138 9.74989 5.30117 9.82604 5.50694 9.83571C5.71271 9.84537 5.91685 9.78818 6.0978 9.67018C6.27875 9.55218 6.42981 9.37773 6.53503 9.16526C6.64026 8.95278 6.69576 8.71014 6.69566 8.46296V7.66234Z",
                                                            fill: "#4B5563"
                                                        })
                                                    }),
                                                    "Responder"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        comment.replies && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubComments, {
                            children: comment.replies.map(function(item, subIndex) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Avatar */.qE, {
                                            size: "lg",
                                            name: item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Right, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                                    children: truncateString(item.name, 20)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menssage, {
                                                    children: item.message
                                                })
                                            ]
                                        })
                                    ]
                                }, "sub-item-".concat(i, "-").concat(subIndex));
                            })
                        })
                    ]
                }, i);
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                ref: formRef,
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Deixe uma resposta"
                    }),
                    (selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                children: [
                                    "Responder para: ",
                                    selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Mensagem: ",
                                    selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.message
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* FormControl */.NI, {
                        isInvalid: errors.name,
                        mb: "24px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("name", {
                                required: "Este campo \xe9 obrigat\xf3rio",
                                minLength: {
                                    value: 3,
                                    message: "O nome deve ter pelo menos 3 caracteres"
                                }
                            })), {
                                type: "text",
                                placeholder: "Nome"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* FormErrorMessage */.J1, {
                                children: errors.name && errors.name.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                        gap: "24px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* FormControl */.NI, {
                                isInvalid: errors.email,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email", {
                                        required: "Este campo \xe9 obrigat\xf3rio",
                                        pattern: {
                                            value: /\S+@\S+\.\S+/,
                                            message: "Digite um email v\xe1lido"
                                        }
                                    })), {
                                        type: "email",
                                        placeholder: "Email"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* FormErrorMessage */.J1, {
                                        children: errors.email && errors.email.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* FormControl */.NI, {
                                isInvalid: errors.confirmarEmail,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("confirmarEmail", {
                                        validate: function(value) {
                                            return value === getValues("email") || "Os emails n\xe3o correspondem";
                                        }
                                    })), {
                                        type: "email",
                                        placeholder: "Confirme seu email"
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* FormErrorMessage */.J1, {
                                        children: errors.confirmarEmail && errors.confirmarEmail.message
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* FormControl */.NI, {
                        isInvalid: errors.message,
                        mt: "24px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("message", {
                                required: "Este campo \xe9 obrigat\xf3rio"
                            })), {
                                placeholder: "Mensagem",
                                resize: "none"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* FormErrorMessage */.J1, {
                                children: errors.message && errors.message.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* FormControl */.NI, {
                        mt: "24px",
                        isInvalid: !isValid(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* FormLabel */.lX, {
                                children: question
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                type: "text",
                                placeholder: "Digite aqui a resposta",
                                onChange: function(event) {
                                    return reply(event.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* FormErrorMessage */.J1, {
                                children: "Por favor, responda a quest\xe3o acima."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Button, {
                        shape: "rounded",
                        disabled: !isValid() || loading,
                        children: [
                            "Enviar coment\xe1rio ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ArrowForwardIcon */.mr, {
                                w: 4,
                                h: 4
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Comments = (Container);


/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var index_esm = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Footer/index.tsx + 2 modules
var Footer = __webpack_require__(7386);
// EXTERNAL MODULE: ./components/Navbar/index.js + 4 modules
var Navbar = __webpack_require__(6697);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
;// CONCATENATED MODULE: ./components/Layout/Default/styles.ts


var Top = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    "& .chakra-breadcrumb": {
        fontFamily: "$raleway",
        fontWeight: 600,
        fontSize: (0,polished_esm/* rem */.hO)(12),
        color: "$grey600",
        "& li": {
            "&:last-of-type": {
                color: "$emerald500"
            }
        }
    }
});
var Background = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    paddingTop: 60,
    backgroundImage: "url(/banner_gramas.webp)",
    backgroundSize: "cover",
    position: "relative"
});
var WrapBox = (0,stitches_config/* styled */.zo)("div", {});
var Box = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    left: "50%",
    marginTop: 90,
    padding: "16px",
    transform: "translateX(-50%)",
    flexDirection: "column",
    background: "$white",
    borderRadius: "32px 32px 0 0",
    textAlign: "center",
    width: "90%",
    "@xl": {
        padding: "16px 90px",
        width: "auto",
        display: "inline-flex"
    }
});
var Category = (0,stitches_config/* styled */.zo)("h1", {
    fontFamily: "$domine",
    fontWeight: "bold",
    color: "$grey900",
    fontSize: (0,polished_esm/* rem */.hO)(24),
    "@md": {
        fontSize: (0,polished_esm/* rem */.hO)(54)
    }
});
var CategorySmall = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: " !important",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var ScientifcName = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: "normal !important",
    fontStyle: "italic",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var Main = (0,stitches_config/* styled */.zo)("main", {
    "& section": {
        paddingTop: 50,
        paddingBottom: 100
    }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./components/Layout/Default/index.tsx













var convertBreadcrumb = function(string) {
    return string.replace(/-/g, " ").replace(/oe/g, "\xf6").replace(/ae/g, "\xe4").replace(/ue/g, "\xfc").charAt(0).toUpperCase() + string.slice(1);
};
function Layout(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), breadcrumbs = ref[0], setBreadcrumbs = ref[1];
    (0,react.useEffect)(function() {
        if (router) {
            var linkPath = router.asPath.split("/");
            linkPath.shift();
            var pathArray = linkPath.map(function(path, i) {
                return {
                    breadcrumb: path.split("?")[0],
                    href: "/" + linkPath.slice(0, i + 1).join("/")
                };
            });
            setBreadcrumbs(pathArray);
        }
    }, [
        router
    ]);
    // if (!breadcrumbs) {
    //   return null
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: props.keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://centraldagrama.com".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://centraldagrama.com/".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Top, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                        css: props.categorySize ? (0,_object_spread/* default */.Z)({}, {
                                            fontSize: "".concat(props.categorySize, " !important")
                                        }) : {},
                                        children: props.category
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Breadcrumb */.aG, {
                                        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ChevronRightIcon */.XC, {
                                            color: "gray.600"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                        children: "In\xedcio"
                                                    })
                                                })
                                            }),
                                            breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(breadcrumb, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: breadcrumb.href,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                            children: convertBreadcrumb(breadcrumb.breadcrumb)
                                                        })
                                                    })
                                                }, i);
                                            })
                                        ]
                                    }),
                                    props.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScientifcName, {
                                        children: props.subtitle
                                    }),
                                    props.h2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySmall, {
                                        children: props.h2
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};


/***/ }),

/***/ 8167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LightGalery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 53 modules
var dist_index_esm = __webpack_require__(3387);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@stitches/react/dist/index.mjs
var dist = __webpack_require__(6744);
;// CONCATENATED MODULE: ./components/LightGalery/styled.ts

var WrapImage = (0,dist/* styled */.zo)("div", {
    width: "100%",
    minHeight: "50vh",
    "& img": {
        height: "auto !important",
        minHeight: "inherit !important",
        minWidth: "90% !important",
        width: " auto !important",
        maxHeight: "85% !important",
        objectFit: "contain"
    }
});
var CloseModalWrapper = (0,dist/* styled */.zo)("div", {
    zIndex: 2,
    height: "42px"
});
var Content = (0,dist/* styled */.zo)("div", {
    zIndex: 1,
    button: {
        right: "-3px"
    }
});
var WrapButtons = (0,dist/* styled */.zo)("div", {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between"
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/LightGalery/index.tsx







var LightGalery = function(param) {
    var _$forwardRef = param.forwardRef, body = param.body;
    var ref = (0,index_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var ref1 = (0,react.useState)(0), currentIndex = ref1[0], setCurrentIndex = ref1[1];
    var ref2 = (0,react.useState)([]), imageAlt = ref2[0], setImageAlt = ref2[1];
    var ref3 = (0,react.useState)([]), images = ref3[0], setImages = ref3[1];
    (0,react.useEffect)(function() {
        if (_$forwardRef === null || _$forwardRef === void 0 ? void 0 : _$forwardRef.current) {
            var _loop = function(index) {
                var ref, ref1;
                var image = imageNodes[index];
                console.log("aqui 1");
                if (!image.getAttribute("src") || ((ref = image.getAttribute("src")) === null || ref === void 0 ? void 0 : ref.includes("base64"))) return "continue";
                console.log("aqui 2");
                image.addEventListener("click", function() {
                    setCurrentIndex(index);
                    onOpen();
                });
                console.log("aqui 3");
                imageAltList.push(((ref1 = image.getAttribute("alt")) === null || ref1 === void 0 ? void 0 : ref1.replace("foto da grama ", "")) || "");
                imageList.push(image.getAttribute("src") || "");
            };
            var imageNodes = _$forwardRef === null || _$forwardRef === void 0 ? void 0 : _$forwardRef.current.querySelectorAll("img");
            var imageList = [];
            var imageAltList = [];
            for(var index = 0; index < imageNodes.length; index++)_loop(index);
            setImages(imageList);
            setImageAlt(imageAltList);
        }
    }, [
        _$forwardRef,
        body
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
        onClose: onClose,
        isOpen: isOpen,
        isCentered: true,
        size: "xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {
                bg: "rgba(0, 0, 0, 0.75)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseModalWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalCloseButton */.ol, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalBody */.fe, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: images[currentIndex] || "",
                                    title: images[currentIndex],
                                    alt: images[currentIndex],
                                    layout: "fill"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
// eslint-disable-next-line react/display-name
var LightGaleryRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LightGalery, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        forwardRef: ref
    }));
});
/* harmony default export */ var components_LightGalery = (LightGaleryRef);


/***/ }),

/***/ 1338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Post_Cover; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
;// CONCATENATED MODULE: ./components/Post/Cover/styles.ts

var Cover = (0,stitches_config/* styled */.zo)("figure", {
    position: "relative",
    width: "100%",
    height: 313,
    borderRadius: 10,
    background: "#C4C4C4",
    overflow: "hidden",
    marginBottom: 22
});

;// CONCATENATED MODULE: ./components/Post/Cover/index.tsx



var Cover_Cover = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "".concat(props.cover),
            title: props.title,
            alt: props.description,
            layout: "fill"
        })
    });
};
/* harmony default export */ var Post_Cover = (Cover_Cover);


/***/ }),

/***/ 64:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AlertComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3038);


function AlertComponent(param) {
    var show = param.show, title = param.title, status = param.status, description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: "9999",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Alert */ .bZ, {
                status: status,
                variant: "subtle",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                height: "200px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertIcon */ .zM, {
                        boxSize: "40px",
                        mr: 0
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertTitle */ .Cd, {
                        mt: 4,
                        mb: 1,
                        fontSize: "lg",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertDescription */ .X, {
                        maxWidth: "sm",
                        children: description
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 3229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3730);


function Loading(param) {
    var isLoading = param.isLoading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: "9999",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Spinner */ .$, {
                size: "xl",
                color: "white"
            })
        })
    });
};


/***/ }),

/***/ 9419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y8": function() { return /* binding */ apiSameOrigin; },
/* harmony export */   "fz": function() { return /* binding */ apiContact; },
/* harmony export */   "hi": function() { return /* binding */ api; },
/* harmony export */   "rY": function() { return /* binding */ apiAcf; }
/* harmony export */ });
/* unused harmony export apiCg */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/wp/v2",
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    }
});
var apiContact = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/contact-form-7/v1/contact-forms",
    headers: {
        "Content-Type": "multipart/form-data"
    },
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    }
});
var apiSameOrigin = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "/api"
});
var apiAcf = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/acf/v3",
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    }
});
var apiCg = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/central-da-grama/v1",
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    },
    headers: {
        "Content-Type": "application/json"
    }
});


/***/ }),

/***/ 5313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ countComments; },
/* harmony export */   "T": function() { return /* binding */ transformHttpToHttps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9815);



var countComments = function(comments) {
    var flatComments = comments.flatMap(function(comment) {
        if (comment.replies) {
            return [
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
                    replies: false
                })
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(comment.replies.map(function(reply) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, reply), {
                    status: false
                });
            })));
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
            replies: false
        });
    });
    var commentsActive = flatComments.filter(function(item) {
        return item.status;
    });
    return (commentsActive === null || commentsActive === void 0 ? void 0 : commentsActive.length) || 0;
};
var transformHttpToHttps = function(url) {
    if (!url) return "";
    return url.replace("http://", "https://");
};


/***/ }),

/***/ 9210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRecaptcha; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useRecaptcha = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), rightResponse = ref[0], setRightResponse = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), question = ref1[0], setQuestion = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), response = ref2[0], setResponse = ref2[1];
    var isValid = function() {
        return rightResponse === response;
    };
    var generateQuestion = function() {
        var a = Math.floor(Math.random() * 101);
        var b = Math.floor(Math.random() * 101);
        setRightResponse(Number(a + b));
        setQuestion("Qual \xe9 o valor da soma ".concat(a, " + ").concat(b, "?"));
    };
    var reply = function(value) {
        var parsedValue = Number(value);
        setResponse(parsedValue);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        generateQuestion();
    }, []);
    return {
        question: question,
        isValid: isValid,
        reply: reply,
        generateQuestion: generateQuestion
    };
};


/***/ }),

/***/ 7243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useRequest; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useRequest = function(requestData, params) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), data = ref[0], setData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), success = ref2[0], setSuccess = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), error = ref3[0], setError = ref3[1];
    var request = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setError(null);
                    setSuccess(false);
                    setIsLoading(true);
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return requestData(params);
                case 6:
                    response = _ctx.sent;
                    setData(response);
                    setSuccess(true);
                    _ctx.next = 15;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](3);
                    setSuccess(false);
                    setError(_ctx.t0);
                case 15:
                    _ctx.prev = 15;
                    setIsLoading(false);
                    return _ctx.finish(15);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                11,
                15,
                18
            ]
        ]);
    })), [
        params,
        requestData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        request();
    }, [
        request
    ]);
    return {
        data: data,
        error: error,
        success: success,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);